import React, { useEffect, useState } from 'react';
import Tab from './Tab';

interface IProps {
  children: React.ReactNode;
  activeTab?: string;
  onTabChanged?: (tab: string) => void;
}

const Tabs: React.FC<IProps> = ({ children, activeTab, onTabChanged }) => {
  
const [initialized, setInitialized] = useState(false);

useEffect(() => {
  if (initialized) return; // Already set initial tab
  
  const childrenArray = React.Children.toArray(children).filter(c => typeof c === 'object');
  
  if (childrenArray.length > 0) {
    const firstLabel = (childrenArray[0] as React.ReactElement).props["data-label"];
    const tabToActivate = activeTab || firstLabel;
    
    if (onTabChanged) {
      onTabChanged(tabToActivate);
      setInitialized(true); // Mark as done
    }
  }
}, [children, activeTab, onTabChanged, initialized]);

  const onClickTabItem = (tab: string) => {
    if (onTabChanged) {
      onTabChanged(tab);
    }
  };

  const childrenArray = React.Children.toArray(children).filter(c => typeof c === 'object');
  return (
    <div className="tabs">
      <ol className="tab-list">
        {childrenArray.map((child) => {
          const label = (child as React.ReactElement).props["data-label"];
          return (
            <Tab
              activeTab={activeTab||''}
              key={label}
              label={label}
              onClick={onClickTabItem}
            />
          );
        })}
      </ol>
      <div className="tab-content">
        {childrenArray.map((child) => {
          const element = child as React.ReactElement;
          if (element.props["data-label"] !== activeTab) return null;
          return element.props.children;
        })}
      </div>
    </div>
  );
};

export default Tabs;